import { AxiosInstance } from 'axios'
import type { MouseEvent } from 'react'
import { getBackboneWindow } from '../getBackboneWindow'
import type { LegalTakeoverData } from './types'

export type { LegalTakeoverData }

function displayTakeover({
  content,
  persistAcceptanceWithSettingsKey,
  title,
}: LegalTakeoverData): void {
  const backboneWindow = getBackboneWindow()

  if (backboneWindow === null) return

  backboneWindow.OpalRadio.Global.execute('takeover:view', {
    content,
    persistAcceptanceWithSettingsKey,
    title,
  })
}

async function fetchData(
  apiClient: AxiosInstance,
  url: string,
  persistAcceptanceWithSettingsKey?: string
) {
  try {
    const response = await apiClient.get(url)
    displayTakeover({
      persistAcceptanceWithSettingsKey,
      ...response.data,
    })
  } catch (error) {
    console.error(error)
  }
}

export function showLegalTakeover(
  apiClient: AxiosInstance,
  urlSource: string,
  persistAcceptanceWithSettingsKey?: string
): Promise<void>
export function showLegalTakeover(
  apiClient: AxiosInstance,
  urlSource: MouseEvent<HTMLAnchorElement>,
  persistAcceptanceWithSettingsKey?: string
): Promise<void>
export async function showLegalTakeover(
  apiClient: AxiosInstance,
  urlSource: MouseEvent<HTMLAnchorElement> | string,
  persistAcceptanceWithSettingsKey?: string
): Promise<void> {
  if (typeof urlSource === 'string') {
    await fetchData(apiClient, urlSource, persistAcceptanceWithSettingsKey)
    return
  }

  urlSource.preventDefault()
  urlSource.stopPropagation()

  const url = urlSource.currentTarget.href
  await fetchData(apiClient, url, persistAcceptanceWithSettingsKey)
}
